export default __webpack_public_path__ + "static/media/solid-group.d04574f9.svg";